import { composeValidators, combineValidators, isRequired } from 'revalidate';
import { hasMinimumLength, isValidEmail, isChecked } from 'helpers/validators';

export const fieldsLabels = {
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email',
  password: 'Password',
  phoneNumber: 'Phone Number',
};

export default (values, props) => combineValidators({
  firstName: isRequired(fieldsLabels.firstName),
  lastName: isRequired(fieldsLabels.lastName),
  email: composeValidators(
    isRequired,
    isValidEmail
  )(fieldsLabels.email),
  password: composeValidators(
    isRequired,
    hasMinimumLength(8)
  )(fieldsLabels.password),
  phoneNumber: isRequired(fieldsLabels.phoneNumber),
  agreementConsent: (value) => {
    if (props.gdprEnabled) {
      return isChecked({ message: 'You must agree to Fountain\'s terms of service to continue' })(value);
    }

    return undefined;
  },
})(values);
